// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"5137":"b4437e56da999275","7643":"b4437e56da999275"}[chunkId] + ".css";
};